"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacebookStaticScript = exports.FacebookDeferredScript = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ssr_1 = require("../../ssr");
const FacebookDeferredScript = () => {
    return (0, jsx_runtime_1.jsx)("script", { id: "fb-script-defer", defer: true, crossOrigin: "anonymous", src: "https://connect.facebook.net/en_US/sdk.js/" });
};
exports.FacebookDeferredScript = FacebookDeferredScript;
const FacebookStaticScript = () => {
    return ((0, jsx_runtime_1.jsx)(ssr_1.StaticHead, { children: (0, jsx_runtime_1.jsx)("script", { id: "fb-script-defer", defer: true, crossOrigin: "anonymous", src: "https://connect.facebook.net/en_US/sdk.js/" }) }));
};
exports.FacebookStaticScript = FacebookStaticScript;
